import React, { useState } from 'react'
import Project from './Project'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { pink } from '@mui/material/colors';
import Filters from '../../Components/Filters';

import Radio from '@mui/material/Radio';

function International() {
  const top100Films = [
    { title: 'The Shawshank Redemption', year: 1994 },
    { title: 'The Godfather', year: 1972 },
    { title: 'The Godfather: Part II', year: 1974 },
    { title: 'The Dark Knight', year: 2008 },
    { title: '12 Angry Men', year: 1957 },
    { title: "Schindler's List", year: 1993 },
    { title: 'Pulp Fiction', year: 1994 },
    {
      title: 'The Lord of the Rings: The Return of the King',
      year: 2003,
    },
    { title: 'The Good, the Bad and the Ugly', year: 1966 },
    { title: 'Fight Club', year: 1999 },
    {
      title: 'The Lord of the Rings: The Fellowship of the Ring',
      year: 2001,
    },
    {
      title: 'Star Wars: Episode V - The Empire Strikes Back',
      year: 1980,
    },
    { title: 'Forrest Gump', year: 1994 },
    { title: 'Inception', year: 2010 },
    {
      title: 'The Lord of the Rings: The Two Towers',
      year: 2002,
    },
    { title: "One Flew Over the Cuckoo's Nest", year: 1975 },
    { title: 'Goodfellas', year: 1990 },
    { title: 'The Matrix', year: 1999 },
    { title: 'Seven Samurai', year: 1954 },
    {
      title: 'Star Wars: Episode IV - A New Hope',
      year: 1977,
    },
    { title: 'City of God', year: 2002 },
    { title: 'Se7en', year: 1995 },
    { title: 'The Silence of the Lambs', year: 1991 },
    { title: "It's a Wonderful Life", year: 1946 },
    { title: 'Life Is Beautiful', year: 1997 },
    { title: 'The Usual Suspects', year: 1995 },
    { title: 'Léon: The Professional', year: 1994 },
    { title: 'Spirited Away', year: 2001 },
    { title: 'Saving Private Ryan', year: 1998 },
    { title: 'Once Upon a Time in the West', year: 1968 },
    { title: 'American History X', year: 1998 },
    { title: 'Interstellar', year: 2014 },
    { title: 'Casablanca', year: 1942 },
    { title: 'City Lights', year: 1931 },
    { title: 'Psycho', year: 1960 },
    { title: 'The Green Mile', year: 1999 },
    { title: 'The Intouchables', year: 2011 },
    { title: 'Modern Times', year: 1936 },
    { title: 'Raiders of the Lost Ark', year: 1981 },
    { title: 'Rear Window', year: 1954 },
    { title: 'The Pianist', year: 2002 },
    { title: 'The Departed', year: 2006 },
    { title: 'Terminator 2: Judgment Day', year: 1991 },
    { title: 'Back to the Future', year: 1985 },
    { title: 'Whiplash', year: 2014 },
    { title: 'Gladiator', year: 2000 },
    { title: 'Memento', year: 2000 },
    { title: 'The Prestige', year: 2006 },
    { title: 'The Lion King', year: 1994 },
    { title: 'Apocalypse Now', year: 1979 },
    { title: 'Alien', year: 1979 },
    { title: 'Sunset Boulevard', year: 1950 },
    {
      title: 'Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb',
      year: 1964,
    },
    { title: 'The Great Dictator', year: 1940 },
    { title: 'Cinema Paradiso', year: 1988 },
    { title: 'The Lives of Others', year: 2006 },
    { title: 'Grave of the Fireflies', year: 1988 },
    { title: 'Paths of Glory', year: 1957 },
    { title: 'Django Unchained', year: 2012 },
    { title: 'The Shining', year: 1980 },
    { title: 'WALL·E', year: 2008 },
    { title: 'American Beauty', year: 1999 },
    { title: 'The Dark Knight Rises', year: 2012 },
    { title: 'Princess Mononoke', year: 1997 },
    { title: 'Aliens', year: 1986 },
    { title: 'Oldboy', year: 2003 },
    { title: 'Once Upon a Time in America', year: 1984 },
    { title: 'Witness for the Prosecution', year: 1957 },
    { title: 'Das Boot', year: 1981 },
    { title: 'Citizen Kane', year: 1941 },
    { title: 'North by Northwest', year: 1959 },
    { title: 'Vertigo', year: 1958 },
    {
      title: 'Star Wars: Episode VI - Return of the Jedi',
      year: 1983,
    },
    { title: 'Reservoir Dogs', year: 1992 },
    { title: 'Braveheart', year: 1995 },
    { title: 'M', year: 1931 },
    { title: 'Requiem for a Dream', year: 2000 },
    { title: 'Amélie', year: 2001 },
    { title: 'A Clockwork Orange', year: 1971 },
    { title: 'Like Stars on Earth', year: 2007 },
    { title: 'Taxi Driver', year: 1976 },
    { title: 'Lawrence of Arabia', year: 1962 },
    { title: 'Double Indemnity', year: 1944 },
    {
      title: 'Eternal Sunshine of the Spotless Mind',
      year: 2004,
    },
    { title: 'Amadeus', year: 1984 },
    { title: 'To Kill a Mockingbird', year: 1962 },
    { title: 'Toy Story 3', year: 2010 },
    { title: 'Logan', year: 2017 },
    { title: 'Full Metal Jacket', year: 1987 },
    { title: 'Dangal', year: 2016 },
    { title: 'The Sting', year: 1973 },
    { title: '2001: A Space Odyssey', year: 1968 },
    { title: "Singin' in the Rain", year: 1952 },
    { title: 'Toy Story', year: 1995 },
    { title: 'Bicycle Thieves', year: 1948 },
    { title: 'The Kid', year: 1921 },
    { title: 'Inglourious Basterds', year: 2009 },
    { title: 'Snatch', year: 2000 },
    { title: '3 Idiots', year: 2009 },
    { title: 'Monty Python and the Holy Grail', year: 1975 },
  ];
  const options = top100Films.map((option) => {
    const firstLetter = option.title[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    };
  });

  // const [paid, setpaid] = useState(true);
  // const [free, setfree] = useState(false);

  // const radiobtn = (method) => {
  //   switch (method) {
  //     case 'paid':
  //       setpaid(true);
  //       setfree(false);
  //       break;
  //     case 'free':
  //       setfree(true);
  //       setpaid(false);
  //       break;

  //   }
  // };

  let  projects= [
    {
        title: "Remote Farming: An smart and advance way of farming",
        category: "Computer Science",
        desc:"Due to the severe climate changes occurring in the India, an IOT solution for weather forecast (especially for the farms in India.." ,
        price: 3000,
        rating: 4,
        teacher:"Praveen soni",
        img:"--"
    },
    {
        title: "CFD Visualization tool with Virtual Reality",
        category: "Virtual Reality",
        desc:"Students who are interested in working on the concept of Virtual reality and help in c..        " ,
        price: 3500,
        rating: 4,
        teacher:"Akash kumar",
        img:"--"
    },
    {
        title: "Applied Vehicle Dynamics Control",
        category: "Matlab",
        desc:"The aim of the course is to give students both theoretical and practical experience of different vehicle dynamics control applica..        " ,
        price: 4500,
        rating: 3.5,
        teacher:"Ema paul",
        img:"--"
    },
    {
        title: "Microsoft Excel for Professionals",
        category: "MS-Excel",
        desc:"This is a course which will impart you the knowledge that is essential for most of the service sector Jobs like consulting, banki..        " ,
        price: 4000,
        rating: 4,
        teacher:"Danis Rauf",
        img:"--"
    },
    {
        title: "Exploring system architecture development of an aircraft.",
        category: "System Architecting",
        desc:"During this project, the present architecture of a regional aircraft (ATR 72) will be explored. We will learn about the different .." ,
        price: 3000,
        rating: 5,
        teacher:"Sahil saif",
        img:"--"
    },
    {
        title: "Solar PV system design in PVSYST",
        category: "Mechanical",
        desc:"1. The vision of this mentorship program is to enable participants to “Design and Simulate SPV System”. 2. The mission of thi.." ,
        price: 3800,
        rating: 4,
        teacher:"Rajat",
        img:"--"
    },
    {
      title: "Microsoft Excel for Professionals",
      category: "MS-Excel",
      desc:"This is a course which will impart you the knowledge that is essential for most of the service sector Jobs like consulting, banki..        " ,
      price: 4500,
      rating: 4.5,
      teacher:"Sushil Sen",
      img:"--"
  },
  {
    title: "Remote Farming: An smart and advance way of farming",
    category: "Computer Science",
    desc:"Due to the severe climate changes occurring in the India, an IOT solution for weather forecast (especially for the farms in India.." ,
    price: 4000,
    rating: 4.5,
    teacher:"Ashis Gupta",
    img:"--"
},
    {
      title: "Exploring system architecture development of an aircraft.",
      category: "System Architecting",
      desc:"During this project, the present architecture of a regional aircraft (ATR 72) will be explored. We will learn about the different .." ,
      price: 5000,
      rating: 4.5,
      teacher:"Ana Smith",
      img:"--"
    },
    {
        title: "CFD Visualization tool with Virtual Reality",
        category: "Virtual Reality",
        desc:"Students who are interested in working on the concept of Virtual reality and help in c..        " ,
        price: 3500,
        rating: 3.5,
        teacher:"Akash kumar",
        img:"--"
    }
]
const [availableProjects, setavailableProjects] = useState(projects)
let handleFiltering = (heading, data) => {
  console.log("hello");
  switch (heading) {
      case "Category":
          if (data == "All") {
              setavailableProjects(projects)
          }
          else {
              let category_items = projects.filter(i => i.category == data);
              setavailableProjects(category_items);
          }
          break
      case "Price Range":
          console.log(data);
          let priceWiseItem = projects.filter(i => i.price >= data[0] && i.price <data[1]);
          console.log(priceWiseItem)
          setavailableProjects(priceWiseItem)
          break
      case "Rating":
          let ratingWiseItem = projects.filter(i => data==Math.floor(i.rating));
          setavailableProjects(ratingWiseItem)
          break
      default:
          break;
  }
}
  return (
    <div>
      <div className="container w-100" style={{ marginTop: "12%" }}>
        <div className="row justify-content-around">
          <div className="col-md-9">
            <h3 className="white-2 text-center">International Projects</h3>
            <div className="d-flex  flex-wrap justify-content-center">
            {availableProjects.map((project) => {
              return <Project title={project.title} category={project.category} desc={project.desc} price={project.price} rating={project.rating} teacher={project.teacher} img={project.img}   />
            })}
            </div>
          </div>
          <div className=" col-md-3 pt-5   justify-content-around">
          <div className="position-fixed " style={{top: '30%'}}>
          <Filters handleFiltering={handleFiltering}  heading="Category" options={["All", "Computer Science", "Virtual Reality", "Matlab", "MS-Excel", "System Architecting", "Mechanical"]} />
          <Filters handleFiltering={handleFiltering}  heading="Price Range" minRange={2000} maxRange={5200} dis={500} intitialrange={[2500,4000]}/>
          <Filters handleFiltering={handleFiltering}  heading="Rating" options={[1, 2, 3,4,5]} />

          </div>
            
          </div>

        </div>
      </div>
    </div>
  )
}

export default International